import React, { useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../Features/userSlice";
import firebase from "firebase";
import db from "../../firebase";
import Modal from "react-modal";
import { Button } from "@material-ui/core";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import "./PostsStyle/AnswerPostModal.css";

Modal.setAppElement("#root");

function AnswerPostModal({
  questionId,
  question,
  timestamp,
  buildFaastUser,
  openModal,
  setOpenModal,
}) {
  const user = useSelector(selectUser);

  const [answer, setAnswer] = useState("");

  const handleAnswer = (e) => {
    e.preventDefault();

    if (user) {
      db.collection("questions")
        .doc(questionId)
        .collection("answer")
        .add({
          questionId: questionId,
          timestamp: firebase.firestore.FieldValue.serverTimestamp(),
          answer: answer,
          user: {
            displayName: user.displayName,
            email: user.email,
            uid: user.uid,
          },
        });
    }
    setOpenModal(false);
  };

  return (
    <div>
      <Modal
        isOpen={openModal}
        disableEnforceFocus
        onRequestClose={() => setOpenModal(false)}
        shouldCloseOnOverlayClick={false}
        style={{
          overlay: {
            width: 750,
            height: 700,
            backgroundColor: "transparent",
            boxShadow:
              "box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);",
            zIndex: "1100",
            top: "60%",
            left: "50%",
            marginTop: "-400px",
            marginLeft: "-395px",
          },
        }}
      >
        <div className="modal__question">
          <h1>{question}</h1>
          <div className="modal__questionFromUser">
            <p>
              Answer by{" "}
              <span className="name">
                {buildFaastUser.displayName
                  ? buildFaastUser.displayName
                  : buildFaastUser.email}
              </span>{" "}
              on{" "}
              <span className="name">
                {new Date(timestamp?.toDate()).toLocaleString()}
              </span>
            </p>
          </div>
        </div>

        <div className="modal__answer">
          <h2>Answer the question here:</h2>
          <CKEditor
            required
            data={answer}
            editor={ClassicEditor}
            onChange={(e, editor) => {
              const data = editor.getData();
              setAnswer(data);
            }}
            type="text"
          />
        </div>
        <div className="modal__button">
          <Button className="cancel" onClick={() => setOpenModal(false)}>
            Cancel
          </Button>
          <Button onClick={handleAnswer} type="submit" className="add">
            Add Answer
          </Button>
        </div>
        <div className="modal__answerGuide"></div>
      </Modal>
    </div>
  );
}

export default AnswerPostModal;
